<template>
    <div>
        <el-card shadow="hover">
            <div>
                <template style="float: left;">
                    <el-button type="primary" size="small" icon="el-icon-document-add" v-has="'PlatAdmin'" @click="doAdd()">添加</el-button>
                    <el-button type="success" size="small" icon="el-icon-download" v-has="'PlatAdmin'" @click="doExport()">导出</el-button>
                    <el-button-group style="margin-left:20px;" v-show="selRows.length > 0">
                        <el-tooltip v-has="'PlatAdmin'" effect="dark" content="删除" placement="top">
                            <el-button size="small" icon="el-icon-delete" @click="doDelete()"></el-button>
                        </el-tooltip>
                        <el-tooltip v-has="'PlatAdmin'" effect="dark" content="重置密码" placement="top">
                            <el-button size="small" icon="el-icon-magic-stick" v-has="'PlatAdmin'" @click="doPasswd()"></el-button>
                        </el-tooltip>
                        <el-tooltip v-has="'PlatAdmin'" effect="dark" content="锁定" placement="top">
                            <el-button size="small" icon="el-icon-lock" v-has="'PlatAdmin'" @click="doLock()"></el-button>
                        </el-tooltip>
                        <el-tooltip v-has="'PlatAdmin'" effect="dark" content="解除锁定" placement="top">
                            <el-button size="small" icon="el-icon-unlock" v-has="'PlatAdmin'" @click="doUnlock()"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>
                <el-form style="float: right" inline :model="query" size="small">
                    <div @keydown.enter="doQuery()">
                        <el-form-item>
                            <el-input v-model="query.name" clearable placeholder="单位名称" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" @selection-change="doSelectionChange" style="width: 100%">
                <el-table-column type="selection" width="40" />
                <el-table-column show-overflow-tooltip label="名称">
                    <template slot-scope="scope">
                        <el-tag type="danger" size="mini" style="margin-right: 10px;" v-if="scope.row.lock.flg">已锁定</el-tag>
                        <span>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="账号" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.key }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="初始密码" width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.dpwd }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="下属单位" width="600">
                    <template slot-scope="scope">
                        <div style=" display: flex; word-wrap: break-word;word-break: break-all;overflow: hidden;">
                            <el-tag type="success" size="mini" v-for="(dept, index) in scope.row.depts" :key="index" style="margin-right: 5px;">{{ dept }}</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" v-has="'PlatAdmin'" @click.stop="doEdit(scope.row)">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
        <!--Form-->
        <el-dialog title="详情" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="formDialog" width="500px">
            <el-form ref="form" :model="field" :rules="rules" label-width="80px">
                <el-form-item label="单位名称" prop="name">
                    <el-input v-model="field.name" placeholder="请填写单位名称"></el-input>
                </el-form-item>
                <el-form-item label="登录账号" prop="key">
                    <el-input v-model="field.key" placeholder="请填写登录账号"></el-input>
                </el-form-item>
                <el-form-item label="下属单位" prop="depts">
                    <el-input type="textarea" :rows="4" v-model="field.depts" placeholder="请填写下属单位，多个以`,`区分"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-circle-check" @click="doSubmit">
                    保存
                </el-button>
                <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="formDialog = false">
                    关闭
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const defaultQuery = {
    page: 1,
    size: 10,
    time: 0,
    name: ''
}
const defaultField = {
    id: '',
    name: '',
    key: '',
    depts: ''
}
export default {
    name: 'SysUnit',
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            tableLoading: false,
            datas: [],
            selRows: [],
            field: {
                ...defaultField
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请填写单位名称',
                        trigger: 'blur'
                    }
                ],
                key: [
                    {
                        required: true,
                        message: '请填写单位账号',
                        trigger: 'blur'
                    }
                ]
            },
            formDialog: false,
            submitLoading: false
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['系统管理', '单位信息'])
        this.init()
    },
    methods: {
        init() {
            this.doLoad()
        },
        doLoad() {
            this.tableLoading = true
            this.$http
                .get('/ops/sys/unit/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                ...defaultQuery
            }
            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        },
        doSelectionChange(rows) {
            this.selRows = rows
        },
        clearFields() {
            this.field = {
                ...defaultField
            }
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
                this.$refs['form'].clearValidate()
            }
        },
        doAdd() {
            this.clearFields()
            this.formDialog = true
        },
        doEdit(item) {
            this.clearFields()
            this.field = {
                ...item
            }
            this.field.depts = item.depts.join()
            this.formDialog = true
        },
        doSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    this.$http.post('/ops/sys/unit/save', this.field).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.formDialog = false
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doDelete(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要删除的内容')
                return
            }
            this.$confirm('是否删除[' + names.join() + ']?删除后将无法恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/sys/unit/delete', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('删除成功')
                            this.doLoad()
                        }
                    })
            })
        },
        doPasswd(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要重置密码的账户')
                return
            }
            this.$confirm('是否重置账户[' + names.join() + ']的密码?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/comm/user/reset', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('重置成功，请使用初始密码登录')
                            this.doLoad()
                        }
                    })
            })
        },
        doLock(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要锁定登录的账户')
                return
            }
            this.$prompt('', '请输入锁定原因', {
                confirmButtonText: '锁定',
                cancelButtonText: '取消',
                inputValue: '账户违规，锁定登录',
                type: 'warning'
            })
                .then(({ value }) => {
                    this.$http
                        .post('/comm/user/lock', {
                            ids: ids.join(),
                            memo: value,
                            hour: 24 * 30 * 6
                        })
                        .then(result => {
                            if (result.code === 0) {
                                this.$message.success('锁定成功')
                                this.doLoad()
                            }
                        })
                })
                .catch(() => {})
        },
        doUnlock(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要解除锁定的账户')
                return
            }
            this.$confirm('是否解除账户[' + names.join() + ']的锁定状态?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/comm/user/unlock', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('解除锁定成功')
                            this.doLoad()
                        }
                    })
            })
        },
        doExport() {
            this.$confirm('导出账号信息，请耐心等待，不要关闭窗口', '提示', {
                confirmButtonText: '开始导出',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/sys/unit/key/export', {
                        _: new Date().getTime()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('导出成功')
                            this.$alert('文件已导出，请<a href="' + result.data.url + '">点击下载</a>导出文件，或右键另存为到本地', '下载文件', {
                                dangerouslyUseHTMLString: true
                            })
                        }
                    })
            })
        }
    }
}
</script>
